import { SelectFieldOption } from '@resurs-internal/mui/components/SelectField/SelectFieldOption';
import { useMemo } from 'react';

import useSettings from '../../hooks/useSettings';
import useTranslation from '../../hooks/useTranslation';
import RadioField from '../RadioField/RadioField';

type Props = {
    name: string;
};

/**
 * The housing-form options for `*HabitationForm`, country-aware in the same way as `LivingConditionField`
 * and `OccupationField`. DK's set is genuinely a different backend enum from NO/SE's, which is why it needs
 * its own branch rather than a shared list.
 *
 * Used by all three accommodation pages -- shared, DK main applicant and DK co-applicant -- so the option
 * set cannot drift between them.
 */
const HabitationFormField = ({ name }: Props) => {
    const translate = useTranslation();
    const { countryCode } = useSettings();

    const habitationFormOptions: SelectFieldOption[] = useMemo<SelectFieldOption[]>(
        () => [
            { id: 'APARTMENT', label: translate('field.accommodation.option.apartment') },
            { id: 'CONDOMINIUM', label: translate('field.accommodation.option.condominium') },
            { id: 'DETACHED_HOUSE', label: translate('field.accommodation.option.detached-house') },
            { id: 'WITH_PARENTS', label: translate('field.accommodation.option.with-parents') },
        ],
        [translate],
    );

    const habitationFormOptionsDK: SelectFieldOption[] = useMemo<SelectFieldOption[]>(
        () => [
            { id: 'DETACHED_HOUSE', label: translate('field.accommodation.option.detached-house') },
            { id: 'CONDOMINIUM', label: translate('field.accommodation.option.condominium') },
            { id: 'HOUSING_COOPERATIVE', label: translate('field.accommodation.option.housing-cooperative') },
            { id: 'APARTMENT', label: translate('field.accommodation.option.apartment') },
            { id: 'OTHER', label: translate('field.accommodation.option.other') },
        ],
        [translate],
    );

    const showOptions = () => {
        switch (countryCode) {
            case 'DK':
                return habitationFormOptionsDK;
            default:
                return habitationFormOptions;
        }
    };

    return <RadioField name={name} options={showOptions()} />;
};

export default HabitationFormField;
